import { SiTwitch } from '@icons-pack/react-simple-icons';

// The one sign-in label: the Twitch mark and "Sign in". The mark already says
// which account, so the words stay short; screen readers get the full phrase.
export default function TwitchSignInLabel({ size = 14 }: { size?: number }) {
  return (
    <span className="inline-flex items-center justify-center gap-1.5">
      <SiTwitch size={size} color="#9146FF" aria-hidden="true" className="shrink-0" />
      <span>
        Sign in<span className="sr-only"> with Twitch</span>
      </span>
    </span>
  );
}
